import React, { useState } from "react";
import StyledModal from "../../../components/CustomModal";
import { FooterButtons, StyledButton } from "../../../components/styles";
import { TextBold, TextWrapper } from "./style";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks/redux";
import { convertIntoBoardTicket, updateTicketLocally } from "../../../redux/features/board/columnsSlice";
import { updateLostItemIsUrgent } from "../../../redux/features/report/reportAsyncThunk";
import { toast } from "react-toastify";

interface ReportModalProps {
  isModalOpen: boolean;
  handleCancel: () => void;
}

const MarkAsUrgentModal: React.FC<ReportModalProps> = ({ isModalOpen, handleCancel }) => {
  const [loading, setLoading] = useState(false);
  const { report } = useAppSelector((state) => state.report);
  const dispatch = useAppDispatch();

  const handleMarkAsUrgent = async () => {
    if (report?.id) {
      setLoading(true);
      try {
        const isUrgent = report?.isUrgent ? false : true;
        const response = await dispatch(updateLostItemIsUrgent({ id: report?.id, isUrgent })).unwrap();
        if (response) {
          await dispatch(updateTicketLocally({ ticket: convertIntoBoardTicket({ ...report, isUrgent }) }));
          handleCancel();
          toast.success(`Item ${isUrgent ? "Mark as" : "Remove from"} urgent successfully`);
        }
      } catch (error) {
        console.log({ error });
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div>
      <StyledModal
        draggable={true}
        title="Update Report Information?"
        open={isModalOpen}
        closeIcon={null}
        footer={
          <FooterButtons>
            <StyledButton onClick={handleCancel} disabled={loading}>
              Cancel
            </StyledButton>
            <StyledButton type="primary" loading={loading} onClick={() => handleMarkAsUrgent()}>
              Update
            </StyledButton>
          </FooterButtons>
        }
        centered
        onCancel={handleCancel}
      >
        <TextWrapper>
          Are you sure you want to mark this report as <TextBold>{report?.isUrgent ? "not " : ""} urgent?</TextBold>
        </TextWrapper>
      </StyledModal>
    </div>
  );
};

export default MarkAsUrgentModal;
